import * as Keys from '../config/componentKeys'
import {
    transformViolationsData,
    transformTotalViolationsData,
    transformTrafficCongestionData,
    transformTurnViolationsData,
    transformRecentViolationsEventData
} from './dashboard'

export function transformData(response: any, key: string, timeKey?: string) {
    switch (key) {
        case Keys.TRAFFIC_CONGESTION:
            return transformTrafficCongestionData(response, timeKey);

        case Keys.VIOLATIONS:
            return transformViolationsData(response);

        case Keys.TOTAL_VIOLATIONS:
            return transformTotalViolationsData(response);

        case Keys.TURN_VIOLATIONS:
            return transformTurnViolationsData(response);

        case Keys.RECENT_VIOLATIONS_EVENT:
            return transformRecentViolationsEventData(response);

        default:
            return {};
    }
}


// WEBPACK FOOTER //
// ./src/dataTransformation/index.ts